import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './PaymentResult.module.css';
import Button from '../components/Button';
import Card from '../components/Card';
import { formatCurrency } from '../utils/helpers';
import { CheckCircleIcon } from '../components/Icons';

function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { transactionId, plan, amount, dongleCount } = location.state || {};

  return (
    <div className={styles.container}>
      <Card className={styles.resultCard}>
        <div className={styles.iconWrapper + ' ' + styles.success}>
          <CheckCircleIcon size={48} />
        </div>
        <h1 className={styles.title}>Payment Successful!</h1>
        <p className={styles.message}>
          Your subscription has been activated successfully.
        </p>

        <div className={styles.receipt}>
          <div className={styles.receiptRow}>
            <span className={styles.receiptLabel}>Transaction ID</span>
            <span className={styles.receiptValue}>{transactionId || 'N/A'}</span>
          </div>
          <div className={styles.receiptRow}>
            <span className={styles.receiptLabel}>Plan</span>
            <span className={styles.receiptValue}>{plan || 'N/A'}</span>
          </div>
          <div className={styles.receiptRow}>
            <span className={styles.receiptLabel}>Dongles</span>
            <span className={styles.receiptValue}>{dongleCount || 1}</span>
          </div>
          <div className={`${styles.receiptRow} ${styles.totalRow}`}>
            <span className={styles.receiptLabel}>Amount Paid (incl. GST)</span>
            <span className={styles.receiptAmount}>{formatCurrency(amount || 0)}</span>
          </div>
        </div>

        <div className={styles.actions}>
          <Button onClick={() => navigate('/subscription')}>
            View Subscription
          </Button>
          <Button variant="secondary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default PaymentSuccess;
